import { SnackbarContent } from "notistack";
import React, { forwardRef } from "react";

import { MessageType } from "../../interfaces";
import { MessageBar } from "./MessageBar";

interface Props {
  message: {
    text: string;
    variant: MessageType;
    className?: string;
    action?: React.FunctionComponent;
    animation?: React.FunctionComponent;
  };
}

export const SnackMessage = forwardRef<HTMLDivElement, Props>(
  ({ message }, ref) => {
    const { text, variant, className, action, animation } = message;

    return (
      <SnackbarContent ref={ref}>
        <MessageBar
          text={text}
          type={variant}
          className={className}
          isSnackbar={true}
          Action={action}
          Animation={animation}
        />
      </SnackbarContent>
    );
  },
);
